import axios from 'axios'
import { vehicle as setLocalStorageVehicle } from '../../../utils/setLocalStorage'

export default {
  namespaced: false,
  state: {
    storeVehicle: undefined,
    upsaleVehicleFull: null,

  },
  mutations: {
    SET_SELECTED_VEHICLE(state, vehicle) {
      state.storeVehicle = vehicle
      setLocalStorageVehicle(vehicle.id)
    },
    SET_UPSALE_VEHICLE_FULL(state, vehicle) {
      state.upsaleVehicleFull = vehicle
    },
  },
  actions: {
    GET_VEHICLE_FROM_ID({ rootState, commit }, vehicleId) {
      axios(`${rootState.api}/vehicles/${vehicleId}`).then((res) => commit('SET_SELECTED_VEHICLE', res.data.data))
    },
    GET_UPSALE_VEHICLE_FULL({ rootState, getters, commit }, vehicleId) {
      const body = { ...getters.dataForPrices, price_per_day: getters.pricePerDay }
      axios.post(`${rootState.api}/vehicles/${vehicleId}/upsale`, body).then((res) => commit('SET_UPSALE_VEHICLE_FULL', res.data.data))
        .catch((err) => {
          console.error(err)
          commit('SET_UPSALE_VEHICLE_FULL', false)
        })
    },
  },
  getters: {
    upsaleVehicle: (state) => state.upsaleVehicleFull || (state.storeVehicle && state.storeVehicle.upsale),
    selectedVehicleIsAvailable: (state, getters, rootState) => {
      if (!state.storeVehicle || !state.storeVehicle.semi_clair) {
        return false
      }
      return rootState.vehicles.availability.allAvailabilities[state.storeVehicle.semi_clair] && rootState.vehicles.availability.allAvailabilities[state.storeVehicle.semi_clair].total
    },
    pricePerDay: (state, getters, rootState) => {
      const storeVehicle = state.storeVehicle.semi_clair
      const prices = rootState.vehicles.prices && rootState.vehicles.prices.allPrices

      if (!storeVehicle || !prices || !prices[storeVehicle]) {
        return
      }
      return prices[storeVehicle].price_per_day
    },
    onlinePrice(state, getters, rootState) {
      const storeVehicle = state.storeVehicle.semi_clair
      const prices = rootState.vehicles.prices && rootState.vehicles.prices.allPrices

      if (!storeVehicle || !prices || !prices[storeVehicle]) {
        return
      }
      /* eslint-disable-next-line camelcase */
      return prices[storeVehicle]?.total_ttc?.value
    },
    offlinePrice(state, getters, rootState) {
      const storeVehicle = state.storeVehicle.semi_clair
      const prices = rootState.vehicles.prices && rootState.vehicles.prices.allPrices

      if (!storeVehicle || !prices || !prices[storeVehicle]) {
        return
      }
      /* eslint-disable-next-line camelcase */
      return prices[storeVehicle]?.total_no_discount?.value
    },
    upsaleVehicleFullStateDefined(state) {
      if (state.upsaleVehicleFull === null) {
        return false
      }
      return true
    },
    canGetFullUpsale: (state, getters) => state.storeVehicle && getters.upsaleVehicle && getters.pricePerDay,
  },
}
